import React from 'react';

import FilterDate from './FilterDate';
import FilterSentiment from './FilterSentiment';
import { Container } from './styles';

const Cockpit = () => {
  return (
    <Container>
      <FilterDate />
      <FilterSentiment />
    </Container>
  );
};

export default Cockpit;
